import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './DaysOfWeekPicker.scss';

export default class DaysOfWeekPicker extends Component {
    constructor(props, context) {
        super(props, context);
    }

    onChange = (e) => {
        this.props.onChange(e.target.checked, parseInt(e.target.value))
    }

    render(){
        const dowOptions = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", 
        "Friday", "Saturday"];
        const invalid = (this.props.daysSelected.length === 0) ? 'invalid' : '';
        const className = (this.props.className) ? this.props.className : '';

        return(
            <div className={"dow-picker mb-3 " + invalid + " " + className}>
                <p>{this.props.label}</p>
                <div>
                {dowOptions.map((dow, i) => 
                    <div key={i}>
                        <input type="checkbox" name="dow" id={i} value={i}
                            onChange={this.onChange}
                            checked={this.props.daysSelected.includes(i)} />
                        <label htmlFor={i}>{dow}</label>
                    </div>
                )}
                </div>
                <div className="invalid-feedback">
                    {this.props.errorMessage}
                </div>
                <div>
                    <a href="https://ehsolution.zendesk.com/hc/en-us/articles/360021729774#h_01FV0VYFZ1XW68ZT1X0G7JMCZT"
                        target="_blank" rel="noopener noreferrer">Learn More</a>
                </div>
            </div> 
        )
    }
}

DaysOfWeekPicker.propTypes = {
    daysSelected: PropTypes.array.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
    className: PropTypes.string,
}